import styled from '@emotion/styled';

import { StatsRow } from './StatsRow';

const Container = styled.div`
  padding: 16px 20px;
  background: #fff;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 18px;
  border-radius: 12px;
  min-width: 280px;
`;

type Props = {
  timeSpent: string;
  timeRemaining: string;
  timeSaved: string;
};

export const StatsOverview = ({ timeSpent, timeRemaining, timeSaved }: Props) => (
  <Container>
    <StatsRow color="#0414A2" label="Time Spent" value={timeSpent} />
    <StatsRow color="#3169F6" label="Time Saved" value={timeSaved} />
    <StatsRow color="#B7CCFF" label="Time Remaining" value={timeRemaining} />
  </Container>
);
